import * as React from 'react';
import { _t } from '@hip/translations';
export const PlusIcon = () => {
    const alt = _t('icons.plus');
    return (React.createElement("svg", { role: "img", "aria-label": alt, width: "16", height: "16", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("title", null, alt),
        React.createElement("path", { d: "M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" })));
};
